export default function (pass, rule) {
    const error = "您输入的密码不一致";
    if (rule.firstPass !== pass) {
        return error;
    }
}